module.exports = __webpack_public_path__ + "static/Booklet-825-08-087de417b0b4872fcd6be5485a7ed0ad.png";